module.exports = "https://mrkt.spotifycdn.com/artists-spotify-com/_next/static/images/footer-android-1e8a7815136447656dae5d9e77dfd5ad.svg";